// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import AccountNewEditForm from '../account-new-edit-form';

// ----------------------------------------------------------------------

export default function AccountNewView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Tạo tài khoản mới"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Tài khoản', href: paths.dashboard.user.list },
          { name: 'Tạo mới' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />
      
      <AccountNewEditForm />
    </Container>
  );
}